import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MouseHoldDirective } from './directives/mouse-hold/mouse-hold.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [MouseHoldDirective],
  exports: [MouseHoldDirective],
})
export class CoreFeaturesMouseHoldModule {}
